import AppLayout from './Layout.vue';
import AppLayoutBody from './Body.vue';
import AppLayoutFooter from './Footer.vue';
import AppLayoutHeader from './Header.vue';
import AppTopNav from './TopNav.vue';
import AppTopNavBack from './TopNavBack.vue';
import AppTopNavTitle from './TopNavTitle.vue';
import AppTopNavSkeleton from './TopNavSkeleton.vue';
import AppLayoutSkeleton from './Skeleton.vue';
import LayoutContent from './Content.vue';
import LayoutMain from './Main.vue';
import LayoutAside from './Aside.vue';
import TopNavBack from './TopNavBack.vue';
import TopNavTitle from './TopNavTitle.vue';
import ContentHeader from './ContentHeader.vue';
import ContentBody from './ContentBody.vue';
import TopNav from './TopNav.vue';
import TopNavMenu from './TopNavMenu.vue';
import TopNavSkeleton from './TopNavSkeleton.vue';
import ContentFooter from './ContentFooter.vue';

export default {
    AppLayout,
    AppLayoutBody,
    AppLayoutFooter,
    AppLayoutHeader,
    AppTopNav,
    AppTopNavBack,
    AppTopNavTitle,
    AppTopNavSkeleton,
    AppLayoutSkeleton,
    LayoutContent,
    LayoutMain,
    TopNav,
    TopNavBack,
    TopNavTitle,
    TopNavMenu,
    TopNavSkeleton,
    ContentHeader,
    ContentBody,
    ContentFooter,
    LayoutAside,
};
